import React from 'react';
import { Incorporadora } from '../../../../types/incorporadora';

interface Props {
  formData: any; // Partial<Empreendimento> ou um tipo mais específico
  handleInputChange: (field: string, value: any) => void;
  errors: Record<string, string>;
  incorporadoras: Incorporadora[];
}

const EmpreendimentoDadosBasicosForm: React.FC<Props> = ({
  formData,
  handleInputChange,
  errors,
  incorporadoras,
}) => {
  return (
    <div className="bg-white shadow overflow-hidden rounded-lg">
      <div className="px-4 py-5 sm:px-6 border-b border-gray-200">
        <h3 className="text-lg leading-6 font-semibold text-gray-900">1. Informações Básicas e Descritivas</h3>
      </div>
      <div className="border-t border-gray-200">
        <div className="px-4 py-5 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          
          {/* Nome do Empreendimento */}
          <div>
            <label className="block text-sm font-medium text-gray-700">Nome do Empreendimento *</label>
            <input
              type="text"
              value={formData.nome || ''}
              onChange={(e) => handleInputChange('nome', e.target.value)}
              className={`mt-1 block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 ${
                errors.nome ? 'border-red-300' : 'border-gray-300'
              }`}
            />
            {errors.nome && <p className="mt-1 text-sm text-red-600">{errors.nome}</p>}
          </div>

          {/* Área Total */}
          <div>
            <label className="block text-sm font-medium text-gray-700">Área Total (m²)</label>
            <input
              type="number"
              min="0"
              value={formData.area_total || ''}
              onChange={(e) => handleInputChange('area_total', e.target.value ? parseFloat(e.target.value) : undefined)}
              className={`mt-1 block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 ${
                errors.area_total ? 'border-red-300' : 'border-gray-300'
              }`}
            />
            {errors.area_total && <p className="mt-1 text-sm text-red-600">{errors.area_total}</p>}
          </div>

          {/* Área Construída */}
          <div>
            <label className="block text-sm font-medium text-gray-700">Área Construída (m²)</label>
            <input
              type="number"
              min="0"
              value={formData.area_construida || ''}
              onChange={(e) => handleInputChange('area_construida', e.target.value ? parseFloat(e.target.value) : undefined)}
              className={`mt-1 block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 ${
                errors.area_construida ? 'border-red-300' : 'border-gray-300'
              }`}
            />
            {errors.area_construida && <p className="mt-1 text-sm text-red-600">{errors.area_construida}</p>}
          </div>
          
          {/* Quantidade de Elevadores */}
          <div>
            <label className="block text-sm font-medium text-gray-700">Quantidade de Elevadores</label>
            <input
              type="number"
              min="0"
              step="1"
              value={formData.elevadores || ''}
              onChange={(e) => handleInputChange('elevadores', e.target.value ? parseInt(e.target.value) : undefined)}
              className={`mt-1 block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 ${
                errors.elevadores ? 'border-red-300' : 'border-gray-300'
              }`}
            />
            {errors.elevadores && <p className="mt-1 text-sm text-red-600">{errors.elevadores}</p>}
          </div>

          {/* Data de Entrega */}
          <div>
            <label className="block text-sm font-medium text-gray-700">Data de Entrega</label>
            <input
              type="date"
              // Usamos split('T')[0] para garantir que o formato 'YYYY-MM-DD' seja lido corretamente pelo input type="date"
              value={formData.data_entrega ? formData.data_entrega.split('T')[0] : ''}
              onChange={(e) => handleInputChange('data_entrega', e.target.value)}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {/* Data de Início da Comercialização */}
          <div>
            <label className="block text-sm font-medium text-gray-700">Início da Comercialização</label>
            <input
              type="date"
              value={formData.data_inicio_comercializacao ? formData.data_inicio_comercializacao.split('T')[0] : ''}
              onChange={(e) => handleInputChange('data_inicio_comercializacao', e.target.value)}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
          
          {/* Heading */}
          <div className="sm:col-span-2 lg:col-span-3">
            <label className="block text-sm font-medium text-gray-700">Heading (Título Chamativo)</label>
            <input
              type="text"
              value={formData.heading || ''}
              onChange={(e) => handleInputChange('heading', e.target.value)}
              className={`mt-1 block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 ${
                errors.heading ? 'border-red-300' : 'border-gray-300'
              }`}
            />
            {errors.heading && <p className="mt-1 text-sm text-red-600">{errors.heading}</p>}
          </div>

          {/* Pitch */}
          <div className="sm:col-span-2 lg:col-span-3">
            <label className="block text-sm font-medium text-gray-700">Pitch (Descrição de Vendas)</label>
            <textarea
              rows={4}
              value={formData.pitch || ''}
              onChange={(e) => handleInputChange('pitch', e.target.value)}
              className={`mt-1 block w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 ${
                errors.pitch ? 'border-red-300' : 'border-gray-300'
              }`}
            />
            {errors.pitch && <p className="mt-1 text-sm text-red-600">{errors.pitch}</p>}
          </div>

        </div>
      </div>
    </div>
  );
};

export default EmpreendimentoDadosBasicosForm;
